<div class="swipe-to-refresh-container">
  <div
    [attr.aria-busy]="isRefreshing"
    [attr.aria-label]="
      isRefreshing
        ? ('Refreshing' | translate)
        : indicatorState === 'ready'
          ? ('Release to refresh' | translate)
          : ('Pull to refresh' | translate)
    "
    [class.pulling]="indicatorState === 'pulling'"
    [class.ready]="indicatorState === 'ready'"
    [class.refreshing]="isRefreshing"
    [class.visible]="showIndicator"
    [style.opacity]="showIndicator ? (isRefreshing || isResetting ? 1 : pullProgress / 100) : 0"
    [style.transform]="'translateX(-50%) translateY(' + (-60 + pullProgress * 0.9) + 'px)'"
    class="pull-indicator"
    role="status"
  >
    <div class="spinner-wrapper">
      <div [style.transform]="'rotate(' + pullProgress * 3.6 + 'deg)'" class="spinner">
        <fa-icon [icon]="['fas', 'sync']"></fa-icon>
      </div>
    </div>
  </div>
</div>
